import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/phone.svg';
import { Icon } from '../Icon/Icon';
export const PhoneIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
